import React, { useState } from 'react'
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import accept from "../../../images/accept.png"
import { handleUserError } from '../../../utils/error';
import userRequest from "../../../utils/userRequest"
import "../Styles/AssetLocation.css";
import ViewportMeta from '../../../utils/ViewportMeta';
import { useTranslation } from 'react-i18next';
import Sidebarfats from '../../../components/sidebar/Sidebarfats';

const AssetLocation = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation()

  const [data, setData] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);
  const [locationTag, setLocationTag] = useState('');

  const handleRowClick = (rowData, index) => {
    setSelectedRowIndex(index);
    setSelectedRow(rowData);

  };

  const handleChangeValue = (e) => {
    setLocationTag(e.target.value);
  }

  const handleForm = (e) => {
    e.preventDefault();

    userRequest.get(`/getAssetMasterEncodeAssetCaptureFinalByLocationTag/${locationTag}`)
      .then(response => {
        console.log(response?.data);
        setData(response?.data ?? []);
        setSelectedRow(response?.data[0] ?? []);
      })

      .catch(error => {
        handleUserError(error)
        console.error(error);
      });
  }
  useEffect(() => {
    const AssetData = JSON.parse(localStorage.getItem('AssetData'));
    setSelectedRow(AssetData);
    localStorage.removeItem('AssetData');
    localStorage.removeItem('navigatePath');
  }, []);

  // Use selectedRow in the component


  const handleNextBtnClick = () => {
    console.log(selectedRow);
    if (selectedRow !== null) {
      console.log("working");
      localStorage.setItem("AssetData", JSON.stringify(selectedRow));
      localStorage.setItem("navigatePath", JSON.stringify('/location'));
      navigate('/member/locationdetails')
    }
  }
  return (
    <>
      <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
          <div className={`z-10 before:animate-pulse my-7 smm:my-10 before:bg-gradient-to-b before:from-gray-900 overflow-hidden before:via-[#00FF00] before:to-gray-900 ${i18n.language === 'ar' ? '2xl:ml-60 smm:mr-0' : '2xl:ml-60 smm:ml-0'}`}>
            <div className={`w-full h-auto px-3 sm:px-5 flex`}>
              <div className="w-full sm:w-1/2 lg:w-[900px] px-6 bg-gray-500 bg-opacity-20  backdrop-filter backdrop-blur-sm text-white z-50 py-4  rounded-lg">
                <div className="w-full flex justify-center text-black font-semibold text-xl mb:2 md:mb-5">
                  {t("ASSET BY LOCATION")}
                </div>
                <form onSubmit={handleForm}>
                  <div className="mt-6 md:mt-10 flex justify-between items-center w-full text-sm md:text-xl py-2 rounded-md">
                    <label htmlFor="total" className="block text-xs font-medium text-black">{t("LOCATION")}</label>
                    <input
                      id="total"
                      onChange={handleChangeValue}
                      className="bg-yellow-300 border text-center border-gray-300 text-gray-900 text-xs font-bold tracking-wider rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[60%] p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />

                    <button type='submit' className="bg-gray-300 hover:bg-gray-400 text-white font-medium py-1 px-6 rounded-r">
                      <span>
                        <img src={accept} className='h-6 w-6' alt='' />
                      </span>
                    </button>

                  </div>

                  <div className="mb-6">
                    <label htmlFor="assetlocationtag" className="block mb-2 text-xs font-medium text-black">Asset Location Details</label>

                    {/* // creae excel like Tables  */}
                    <div className="table-location-generate">
                      <table className={` ${i18n.language === 'ar' ? 'direction-rtl' : 'direction-ltr'}`}>
                        <thead>
                          <tr>
                            <th>{t("Asset Description")}</th>
                            <th>{t("Serial No")}</th>
                            <th>{t("Tags Number")}</th>
                            <th>{t("Minor Description")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.length > 0 &&
                            data.map((item, index) => {
                              return (
                                <tr
                                  key={index}
                                  onClick={() => handleRowClick(item, index)}
                                  style={{ backgroundColor: selectedRowIndex === index && 'orange' }}
                                >
                                  <td>{item.aSSETdESCRIPTION}</td>
                                  <td>{item.sERIALnUMBER}</td>
                                  <td>{item.TagNumber}</td>
                                  <td>{item.MinorCategoryDescription}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                      </table>
                    </div>
                  </div >

                  <div className="mb-6">
                    <span
                      onClick={handleNextBtnClick}
                    >
                      <button
                        // onClick={() => navigate('member/locationdetails')}
                        className="bg-gray-300 hover:bg-gray-400 border border-gray-300 font-bold tracking-wider text-gray-900 text-xs rounded-lg block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      >
                        {t("Click the Asset For More Details")}
                      </button>
                    </span>
                  </div>

                  <div className={`mt-4 md:mt-10 flex justify-between items-center w-full text-sm md:text-xl py-2 rounded-md  ${i18n.language === 'ar' ? 'flex-row-reverse' : 'flex-row'}`}>
                    <button onClick={() => navigate('/member/assets')} type='submit' className="bg-[#00006B] text-white font-bold py-2 px-7 rounded-l">
                      {t("Back")}
                    </button>

                    <label htmlFor="total" className={`block text-xs font-medium text-black ${i18n.language==='ar'?' mr-10':'ml-8'}`}>{t("Total Assets")}</label>
                    <input
                      id="total"
                      value={data.length}
                      className="bg-gray-50 border text-center border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-[50%] p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                  </div>
                </form >
              </div >
            </div >
          </div >
      </div>
    </>
  )
}

export default AssetLocation